// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__3IktG","modalFooterButton":"ModalNotes_modalFooterButton__33kSc"};